var exports = {
  "kL": "HandoffApprovalFlow.module__container___cDFyQT",
  "DD": "HandoffApprovalFlow.module__title___cDFyQT",
  "h_": "HandoffApprovalFlow.module__description___cDFyQT",
  "BB": "HandoffApprovalFlow.module__codeInputSection___cDFyQT",
  "IX": "HandoffApprovalFlow.module__codeInput___cDFyQT",
  "aY": "HandoffApprovalFlow.module__code___cDFyQT",
  "YG": "HandoffApprovalFlow.module__matchCheck___cDFyQT",
  "Gp": "HandoffApprovalFlow.module__accountLine___cDFyQT",
  "Hh": "HandoffApprovalFlow.module__wrongAccount___cDFyQT",
  "uX": "HandoffApprovalFlow.module__textButton___cDFyQT",
  "N8": "HandoffApprovalFlow.module__deviceCard___cDFyQT",
  "fz": "HandoffApprovalFlow.module__deviceRow___cDFyQT",
  "hV": "HandoffApprovalFlow.module__deviceLabel___cDFyQT",
  "sv": "HandoffApprovalFlow.module__deviceValue___cDFyQT",
  "v0": "HandoffApprovalFlow.module__buttonRow___cDFyQT",
  "u1": "HandoffApprovalFlow.module__spinner___cDFyQT",
  "z3": "HandoffApprovalFlow.module__error___cDFyQT",
  "FU": "HandoffApprovalFlow.module__successIcon___cDFyQT",
  "bS": "HandoffApprovalFlow.module__deniedIcon___cDFyQT",
};

module.exports = exports;
